import React from "react";
import PropTypes from "prop-types";
import RSBreadcrumb from "reactstrap/lib/Breadcrumb";
import BreadcrumbItem from "reactstrap/lib/BreadcrumbItem";

import { gatherClasses, isFunction, requiredIf } from "../../lib/utils";
import "./breadcrumb.scss";

const Breadcrumb = props => {
  const { dataTestId, items, onItemClick } = props;
  return (
    <div>
      <RSBreadcrumb className={gatherClasses(props)} data-testid={dataTestId}>
        {items.map((item, index) => {
          return (
            <BreadcrumbItem key={index}>
              {isFunction(item.renderComponent) ? (
                item.renderComponent(item)
              ) : (
                <a
                  href={item.href}
                  onClick={e => {
                    if (isFunction(onItemClick)) {
                      onItemClick(e, item);
                    }
                  }}
                >
                  {item.label}
                </a>
              )}
            </BreadcrumbItem>
          );
        })}
      </RSBreadcrumb>
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: requiredIf(
        PropTypes.string,
        props => !isFunction(props.renderComponent)
      ),
      href: requiredIf(
        PropTypes.string,
        props => !isFunction(props.renderComponent)
      ),
      renderComponent: PropTypes.func
    })
  ).isRequired,
  onItemClick: PropTypes.func,
  dataTestId: PropTypes.string
};

Breadcrumb.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  items: [],
  dataTestId: "orion-breadcrumb"
};

Breadcrumb.displayName = "OrionBreadcrumb";

export default Breadcrumb;
